import { translate } from "ui/i18n";
import { useAppDispatch, useAppSelector } from "ui/hook/store";
import { resendVerifyUser } from "domain/auth/auth.actions";
import {
  selectIsAuthenticationLoading,
  selectUserId,
} from "domain/auth/auth.selectors";
import { useLocation, useNavigate } from "react-router-dom";
import { ConfirmPlan } from "ui/assets/svg/ConfirmPlan";
import { PrimaryButton } from "ui/pages/app/components/buttons/PrimaryButton";
import { useWindowWidth } from "ui/utils/hooks";
import { Trans } from "react-i18next";
import { i18nKey } from "domain/entities/activities.entities";

export function ConfirmPlanChoice() {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector(selectIsAuthenticationLoading);
  const isDesktop = useWindowWidth();
  const location = useLocation();
  const navigate = useNavigate();

  const email = location.state?.email;
  const quoteSent = location.state?.quoteSent;
  const isLogged = useAppSelector(selectUserId);

  const resendEmail = async () => {
    if (email) {
      await dispatch(
        resendVerifyUser({ action: "resendVerifySignup", value: { email } })
      );
    }
  };

  const handleNextClick = () => {
    navigate("/account");
  };

  return (
    <div className="flex flex-col items-center">
      {!quoteSent && (
        <h2 className="text-center" style={{ whiteSpace: "pre-line" }}>
          {translate("ns1:ConfirmPlanChoice.ChoiceTakenIntoAccount")}
        </h2>
      )}
      {!isLogged && quoteSent && (
        <>
          <h2 className="text-center" style={{ whiteSpace: "pre-line" }}>
            {translate("ns1:ConfirmPlanChoice.RequestSent")}
          </h2>
          <h4 className="mt-2 text-center text-sm md:mt-4 md:text-lg">
            {translate("ns1:ConfirmPlanChoice.Meanwhile")}
          </h4>
        </>
      )}
      {!isLogged && email && (
        <h4 className="mt-2 text-center text-sm md:mt-4 md:text-lg">
          <Trans
            i18nKey={"Register.ConfirmationByEmailText" as i18nKey}
            values={{ email }}
          />
        </h4>
      )}
      {!isLogged && !email && !quoteSent && (
        <>
          <h4 className="mt-2 text-center text-sm md:mt-4 md:text-lg">
            {translate("ns1:ConfirmPlanChoice.IfYouJustCreated1")}
          </h4>
          <h4 className="text-center text-sm md:text-lg">
            {translate("ns1:ConfirmPlanChoice.IfYouJustCreated2")}
          </h4>
        </>
      )}

      <div className="mt-2 w-full max-w-[500px]">
        <ConfirmPlan />
      </div>

      {!isLogged && (
        <>
          <div className="text-center text-sm font-medium text-darkGrey-700 md:text-base">
            {translate("ns1:Register.NothingReceived")}
          </div>
          <button
            onClick={resendEmail}
            className="text-sm font-bold text-darkGrey-700 underline md:text-base"
            disabled={isLoading}
          >
            {translate("ns1:Register.SendEmailAgain")}
          </button>
        </>
      )}

      {isLogged && (
        <PrimaryButton
          className="w-full max-w-[500px]"
          height={isDesktop ? "56px" : "46px"}
          onClick={handleNextClick}
        >
          {translate("ns1:Button.Next")}
        </PrimaryButton>
      )}
    </div>
  );
}
